import apiClient from '../api/apiClient';
import purchaseDealSheetService from './purchaseDealSheetService';

const BASE = '/api/v1/admin/trade-commitments';

const unwrap = (response) => response.data?.data ?? response.data;

export const DIRECTION_LABELS = { SELL: 'Sell', BUY: 'Buy' };
export const STATUS_LABELS = { ACTIVE: 'Active', CONVERTED: 'Converted', CANCELLED: 'Cancelled' };
export const PAYMENT_STATUS_LABELS = { UNPAID: 'Unpaid', PARTIAL: 'Partial', PAID: 'Paid' };
export const DELIVERY_STATUS_LABELS = { PENDING: 'Pending', PARTIAL: 'Partial', DELIVERED: 'Delivered' };

const tradeCommitmentService = {
  list: async (params = {}) => {
    const response = await apiClient.get(BASE, { params });
    return unwrap(response);
  },

  get: async (id) => {
    const response = await apiClient.get(`${BASE}/${id}`);
    return unwrap(response);
  },

  create: async (body) => {
    const response = await apiClient.post(BASE, body);
    return unwrap(response);
  },

  createSpread: async (body) => {
    const response = await apiClient.post(`${BASE}/spread`, body);
    return unwrap(response);
  },

  update: async (id, body) => {
    const response = await apiClient.patch(`${BASE}/${id}`, body);
    return unwrap(response);
  },

  cancel: async (id) => {
    const response = await apiClient.post(`${BASE}/${id}/cancel`);
    return unwrap(response);
  },

  addPayment: async (id, body) => {
    const response = await apiClient.post(`${BASE}/${id}/payments`, body);
    return unwrap(response);
  },

  getLedgerSummary: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/summary/ledger`, { params });
    return unwrap(response);
  },

  getPositionSummary: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/summary/position`, { params });
    return unwrap(response);
  },

  getPayablesSummary: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/summary/payables`, { params });
    return unwrap(response);
  },

  getReceivablesSummary: async (params = {}) => {
    const response = await apiClient.get(`${BASE}/summary/receivables`, { params });
    return unwrap(response);
  },

  convertToOrder: async (id, body) => {
    const response = await apiClient.post(`${BASE}/${id}/convert/order`, body);
    return unwrap(response);
  },

  convertToPurchaseDealSheet: async (id, body) => {
    const response = await apiClient.post(`${BASE}/${id}/convert/purchase-deal-sheet`, body);
    return unwrap(response);
  },

  getSuggestedLinks: async (id) => {
    const response = await apiClient.get(`${BASE}/${id}/suggested-links`);
    return unwrap(response);
  },

  linkToPurchaseDealSheet: async (id, purchaseDealSheetId) => {
    const response = await apiClient.post(`${BASE}/${id}/link/purchase-deal-sheet`, {
      purchase_deal_sheet_id: purchaseDealSheetId,
    });
    return unwrap(response);
  },

  linkToOrder: async (id, orderId) => {
    const response = await apiClient.post(`${BASE}/${id}/link/order`, { order_id: orderId });
    return unwrap(response);
  },

  listProducts: purchaseDealSheetService.listProducts,
};

export default tradeCommitmentService;
